module.exports = __webpack_public_path__ + "media/Pinwheel11051.6cf04b4b.mp4";